import './Skeleton.scss';

import React from 'react';

const Skeleton = ({ amount = 4 }: { amount?: number }) =>
  Array.from({ length: amount }).map((_, index) => (
    <div className="skeleton" key={index}>
      <div className="skeleton-title" />
      <div className="skeleton-description" />
    </div>
  ));

export default Skeleton;
